import { isSunRangeInvalid, sunHoursLabel } from "@/app/lib/sunHours";

interface SunHoursPickerProps {
  start: string;
  end: string;
  onStartChange: (v: string) => void;
  onEndChange: (v: string) => void;
  headingStyle?: "section" | "label";
  showDescription?: boolean;
}

export function SunHoursPicker({
  start,
  end,
  onStartChange,
  onEndChange,
  headingStyle = "label",
  showDescription = true,
}: SunHoursPickerProps) {
  const summary = sunHoursLabel(start || null, end || null);
  const invalid = isSunRangeInvalid(start || null, end || null);
  return (
    <>
      <div className="flex items-center justify-between gap-3 mt-1">
        {headingStyle === "section" ? (
          <h3 className="form-h mb-0 shrink-0">Sun hours</h3>
        ) : (
          <span className="text-xs uppercase tracking-[0.06em] text-ink-3 font-medium">Sun hours</span>
        )}
        {summary ? <span className="font-sans text-xs text-ink-3 text-right">{summary}</span> : null}
      </div>
      <div className="grid grid-cols-2 gap-2 [&_.field-input-bare]:bg-paper [&_.field-input-bare]:border-[1.5px] [&_.field-input-bare]:border-line [&_.field-input-bare]:rounded-[10px] [&_.field-input-bare]:w-full [&_.field-input-bare:focus]:border-moss-2 [&_.field-input-bare:focus]:outline-none">
        <input
          className="field-input-bare"
          type="time"
          aria-label="Sun start"
          value={start}
          onChange={(e) => onStartChange(e.target.value)}
        />
        <input
          className="field-input-bare"
          type="time"
          aria-label="Sun end"
          value={end}
          onChange={(e) => onEndChange(e.target.value)}
        />
      </div>
      {invalid ? (
        <p className="font-sans text-xs text-ink-3 m-0 leading-snug">
          End time must be after start time.
        </p>
      ) : showDescription ? (
        <p className="font-sans text-xs text-ink-3 m-0 leading-snug">
          When direct sun first hits this pot and when it leaves. Used to plan watering.
        </p>
      ) : null}
    </>
  );
}
